import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useMsal, useIsAuthenticated} from "@azure/msal-react";
import { UploadFlowProvider } from "./contexts/UploadFlowContext";  
import UploadBoth from "./pages/UploadBoth";
import HomePage from "./pages/Home";  
import LogoHeader from "./components/LogoHeader";

// Create a component with the refresh logic that wraps the children
const RefreshHandler = ({ children }) => {
  useEffect(() => {
    // More reliable refresh detection that works in all environments
    const pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) ||
      window.performance.getEntriesByType('navigation')
        .map((nav) => nav.type)
        .includes('reload')
    );
    
    if (pageAccessedByReload) {
      // console.log("📋 Page was refreshed - redirecting to home");
      window.location.href = '/';
    }
  }, []);
  
  return children;
};

const App = () => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();  // MSAL hook: true if a user is logged in

  useEffect(() => {
    // On app load, if not already authenticated, redirect to Azure AD login
    if (inProgress === "none" && !isAuthenticated) {
      // Avoid triggering another redirect if one is already in progress
      instance.loginRedirect();
    }
  }, [inProgress, isAuthenticated, instance]);

  if (!isAuthenticated) {
    // While redirecting or if not logged in yet, you can render a fallback (or null)
    return <div style={{ textAlign: "center", marginTop: "20%" }}>Redirecting to Microsoft login...</div>;
  }

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  // If authenticated, render the protected app routes
  return (
    <UploadFlowProvider>
      <BrowserRouter>
        <RefreshHandler>
          <LogoHeader />
          <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px", backgroundColor: "#f0f0f0", alignItems: "center" , fontSize: "22px", height: "40px"}}>
            <div>
              👋 {accounts[0]?.username || "User"}
            </div>
            <button
              onClick={handleLogout}
              style={{
                padding: "6px 12px",
                fontSize: "18px",
                backgroundColor: "#e74c3c",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Log Out
            </button>
          </div>

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/upload" element={<UploadBoth />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </RefreshHandler>
      </BrowserRouter>
    </UploadFlowProvider>
  );
};

export default App;
